export default {
    space: '2rem',
    radius: '5px',
};
